import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import Footer from "../footer";
import Header from "../header";

import { handleNumberKeyDown, handleOverviewKeyDown } from "../../utils";
import { loadDistricts, loadCategory, loadTaluks, getSocietyInfo, sendRegistrationOTP, verifyRegistrationOTP, registerSecretarySeat } from "../../apiCalls/registerService";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Register() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showcPassword, setShowxPassword] = useState(false);
    const [category,setCategory] = useState([])
    const [loadingCategories,setLoadingCategories] =useState(false)
    const [districts, setDistricts] = useState([]);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [taluks, setTaluks] = useState([]);
    const [loadingTaluks, setLoadingTaluks] = useState(false);
    const [loadingSocietyInfo, setLoadingSocietyInfo] = useState(false);
    const [hasValidationError, setHasValidationError] = useState(false);
    const [sendingOTP, setSendingOTP] = useState(false);
    const [verifyingOTP, setVerifyingOTP] = useState(false);
    const [resendCooldown, setResendCooldown] = useState(0);
    const [showingSuccessToast, setShowingSuccessToast] = useState(false);
    const [pendingNextStep, setPendingNextStep] = useState(false);
    const [submittingRegistration, setSubmittingRegistration] = useState(false);


    const [form, setForm] = useState({
        societyCategory: "",
        societydistrict: "",
        societyTaluk: "",
        registrationNumber: "",

        secretaryName: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        declarationStatus: false,
        step: 1,
        otpSent: false,
        otpVerificationStatus: false,
    });
    const clearForm = () => {
        setForm({
            societyCategory: "",
            societydistrict: "",
            societyTaluk: "",
            registrationNumber: "",
            secretaryName: "",
            mobileNumber: "",
            password: "",
            confirmPassword: "",
            declarationStatus: false,
            step: 1,
            otpSent: false,
            otpVerificationStatus: false,
        })
        setAutoPopDetails({
            name: "",
            emailId: "",
            rcsUniqueCode: "",
            societyBranchId: "",
        })
        setOtp(["", "", "", "", "", ""]);
        setOtpPrefix("");
    }
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [otpPrefix, setOtpPrefix] = useState("");
    const [autoPopDetails, setAutoPopDetails] = useState({
        name: "",
        emailId: "",
        rcsUniqueCode: "",
        societyBranchId: "",
    });
     useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        //Load Select Categories on Mount
        fetchSelectCategory()
        // Load districts on component mount
        fetchDistricts();
    }, []);
    const fetchSelectCategory = async () => {
        setLoadingCategories(true);
        try {
            const result = await loadCategory();
            if (result.status === "success") {
                setCategory(result.data);
            }
        } catch (error) {
            // Error loading categories
        } finally {
            setLoadingCategories(false);
        }
    }
    const fetchDistricts = async () => {
        setLoadingDistricts(true);
        try {
            const result = await loadDistricts();
            if (result.status === "success") {
                setDistricts(result.data);
            }
        } catch (error) {
            // Error loading districts
        } finally {
            setLoadingDistricts(false);
        }
    };

    const fetchTaluks = async (districtId) => {
        if (!districtId) {
            setTaluks([]);
            return;
        }

        setLoadingTaluks(true);
        try {
            const result = await loadTaluks(districtId);
            if (result.status === "success") {
                setTaluks(result.data);
            } else {
                setTaluks([]);
            }
        } catch (error) {
            setTaluks([]);
        } finally {
            setLoadingTaluks(false);
        }
    };

    const fetchSocietyInfo = async (regNo) => {
        // Validate that all required fields are filled
        if (!form.societyCategory || !form.societydistrict || !form.societyTaluk || !regNo) {
            return false;
        }

        const fieldLabel = isKeralaBank() ? "Branch Code" : "Registration Number";
        const getErrorMessage = (apiMessage) => {
            const msg = (apiMessage || "").toLowerCase();
            if (msg.includes("already exist") || msg.includes("already registered")) {
                return `${fieldLabel} already exists`;
            } else if (msg.includes("invalid")) {
                return `Invalid ${fieldLabel}`;
            } else {
                return "Society Not Found";
            }
        };

        setLoadingSocietyInfo(true);
        try {
            const result = await getSocietyInfo({
                districtId: form.societydistrict,
                talukId: form.societyTaluk,
                societyCategoryId: form.societyCategory,
                regNo: regNo,
            });

            if (result.status === "success") {
                // Auto-populate society details
                setAutoPopDetails({
                    name: result.data.name,
                    emailId: result.data.email,
                    rcsUniqueCode: result.data.rcs_unique_code,
                    societyBranchId: result.data.branch_id,
                });
                return true;
            } else {
                const errorContent = (
                    <div>
                        <strong>Validation Error</strong>
                        <div style={{ marginTop: '5px' }}>{getErrorMessage(result.message)}</div>
                    </div>
                );
                setHasValidationError(true);
                toast.error(errorContent, {
                    toastId: "registration-error",
                    onClose: () => setHasValidationError(false)
                });
                return false;
            }
        } catch (error) {
            const errorContent = (
                <div>
                    <strong>Validation Error</strong>
                    <div style={{ marginTop: '5px' }}>{getErrorMessage(error?.message)}</div>
                </div>
            );
            setHasValidationError(true);
            toast.error(errorContent, {
                toastId: "registration-error",
                onClose: () => setHasValidationError(false)
            });
            return false;
        } finally {
            setLoadingSocietyInfo(false);
        }
    };

   

    const handleOtpChange = (value, index) => {
        if (!/^\d?$/.test(value)) return; // allow only digits

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto focus next input
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const navigate = useNavigate();

    // Helper function to check if selected category is Kerala Bank
    const isKeralaBank = () => {
        if (!form.societyCategory || category.length === 0) return false;
        const selectedCategory = category.find(cat => cat.id === form.societyCategory);
        return selectedCategory?.name?.toLowerCase().includes('kerala bank');
    };
    // Helper function to check if selected category is any bank (Kerala Bank or PCARD Bank)
    const isBank = () => {
        if (!form.societyCategory || category.length === 0) return false;
        const selectedCategory = category.find(cat => cat.id === form.societyCategory);
        return selectedCategory?.name?.toLowerCase().includes('bank');
    };
    const handleChange = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
        setErrors((prev) => ({ ...prev, [key]: "" }));
        setHasValidationError(false);

        // When district changes, load taluks and reset taluk selection
        if (key === "societydistrict") {
            setForm((prev) => ({ ...prev, societyTaluk: "" })); // Reset taluk
            fetchTaluks(value); // Load taluks for selected district
        }

        // If any step 1 field changes, reset OTP state so step 2 requires fresh verification
        const step1Fields = ["societyCategory", "societydistrict", "societyTaluk", "registrationNumber"];
        if (step1Fields.includes(key)) {
            setForm((prev) => ({ ...prev, otpSent: false, otpVerificationStatus: false }));
            setOtp(["", "", "", "", "", ""]);
            setResendCooldown(0);
        }
    };
    const progressPercent = (form.step - 1) * 33.33; // 4 steps total
    
    useEffect(() => {
        if (resendCooldown <= 0) return;
        const interval = setInterval(() => {
            setResendCooldown((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [resendCooldown]);

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            document.getElementById(`otp-${index - 1}`).focus();
        }
    }
    useEffect(() => {
        if (form?.otpSent) {
            document.getElementById(`otp-${0}`)?.focus();
        }
    }, [form?.otpSent]);

    useEffect(() => {
        if (!showingSuccessToast && pendingNextStep) {
            setPendingNextStep(false);
            setForm((prev) => ({ ...prev, step: 3 }));
            setErrors((prev) => ({ ...prev, step: "" }));
        }
    }, [showingSuccessToast, pendingNextStep]);

    // Prevent body scroll when off-canvas is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => { document.body.style.overflow = ""; };
    }, [menuOpen]);

    const handleSendOTP = async () => {
        // Check if society branch ID is available
        if (!autoPopDetails.societyBranchId) {
            toast.error("Society information not available. Please complete Step 1 first.");
            return;
        }

        setSendingOTP(true);
        try {
            const result = await sendRegistrationOTP(autoPopDetails.societyBranchId);

            if (result.status === "success") {
                toast.success(`OTP sent successfully to ${autoPopDetails.emailId}`);
                setForm((prev) => ({ ...prev, otpSent: true }));
                setOtpPrefix(result.otp_prefix || "");
                setResendCooldown(30);
            } else {
                toast.error(result.message || "Failed to send OTP. Please try again.");
            }
        } catch (error) {
            toast.error(error.message || "An error occurred while sending OTP. Please try again.");
        } finally {
            setSendingOTP(false);
        }
    };


    const handleSubmit = () => {
        if (form?.step === 1) {
            validatePage1()
        } else if (form?.step === 2) {
            if (!form.otpVerificationStatus) {
                toast.error("Please verify OTP before continuing.");
                return;
            }
            if (showingSuccessToast) {
                setPendingNextStep(true);
            } else {
                handleChange("step", form.step + 1);
            }
        } else if (form?.step === 3) {
            validatePage4()
        }
    }

    const handleVerifyOTP = async () => {
        const otpValue = otp.join("");

        if (!form.otpSent) {
            toast.error("Please send OTP to your registered email first.");
            return;
        }

        if (otpValue.length !== 6) {
            toast.error("Please enter the complete 6-digit OTP.");
            return;
        }

        if (!autoPopDetails.societyBranchId) {
            toast.error("Society information not available. Please restart from Step 1.");
            return;
        }

        setVerifyingOTP(true);
        try {
            const result = await verifyRegistrationOTP(autoPopDetails.societyBranchId, otpValue);
            if (result.status === "success") {
                setShowingSuccessToast(true);
                toast.success("OTP verified successfully!", {
                    onClose: () => setShowingSuccessToast(false)
                });
                setForm((prev) => ({ ...prev, otpVerificationStatus: true }));
                setResendCooldown(0);
            } else {
                toast.error(result.message || "Invalid OTP. Please check and try again.");
            }
        } catch (error) {
            toast.error(error?.message || "OTP verification failed. Please try again.");
        } finally {
            setVerifyingOTP(false);
        }
    }

    const handleResendOTP = () => {
        setOtp(["", "", "", "", "", ""]);
        setForm((prev) => ({ ...prev, otpVerificationStatus: false }));
        handleSendOTP();
    }
    const validatePage1 = async () => {
        const newErrors = {};
        const fieldLabel = isKeralaBank() ? "Branch Code" : "Registration Number";

        if (form.societyCategory === "") newErrors.societyCategory = "Society Category is required";
        if (form.societydistrict === "") newErrors.societydistrict = "Society district is required";
        if (form.societyTaluk === "") newErrors.societyTaluk = "Society taluk is required";
        if (form.registrationNumber === "") newErrors.registrationNumber = `${fieldLabel} is required`;

        if (Object.keys(newErrors).length) {
            setErrors(newErrors);
            return;
        }

        // Validate registration number via API
        const isValid = await fetchSocietyInfo(form.registrationNumber);
        if (!isValid) {
            // Invalid registration number - stay on current step
            return;
        }

        // Proceed to next step only if all validations pass
        handleChange("step", form?.step + 1);
    }
    const validatePage4 = async () => {
        const passwordRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        const newErrors = {};

        // Secretary Name validation
        if (form.secretaryName === "") {
            newErrors.secretaryName = "Secretary Name is required";
        } else if (form.secretaryName.length > 25) {
            newErrors.secretaryName = "Secretary Name must not exceed 25 characters";
        } else if (!/^[a-zA-Z\s]+$/.test(form.secretaryName)) {
            newErrors.secretaryName = "Secretary Name must contain only alphabets and spaces";
        }

        // Mobile Number validation
        if (form.mobileNumber === "") {
            newErrors.mobileNumber = "Mobile Number is required";
        } else if (!/^[6-9]\d{9}$/.test(form.mobileNumber)) {
            newErrors.mobileNumber = "Mobile number must be 10 digits and start with 6/7/8/9";
        }

        // Password validation
        if (form.password === "") {
            newErrors.password = "Password is required";
        } else if (form.password.length > 12) {
            newErrors.password = "Password must not exceed 12 characters";
        }else if (!passwordRegex.test(form.password)) {
            newErrors.password = "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character (@$!%*?&) and min 8 characters";
        }

        // Confirm Password validation
        if (form.confirmPassword === "") {
            newErrors.confirmPassword = "Confirm Password is required";
        } else if (form.confirmPassword.length > 12) {
            newErrors.confirmPassword = "Password must not exceed 12 characters";
        } else if (form.password && form.confirmPassword && form.password !== form.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        // Declaration validation
        if (form.declarationStatus === false) {
            newErrors.declarationStatus = "Please confirm the declaration";
        }

        if (Object.keys(newErrors).length) {
            setErrors(newErrors);
            return;
        }

        if (!autoPopDetails.societyBranchId) {
            toast.error("Society information not available");
            return;
        }

flushSync(() => setSubmittingRegistration(true));
        try {
            const result = await registerSecretarySeat({
                societyBranchId: autoPopDetails.societyBranchId,
                secretaryName: form.secretaryName,
                mobileNumber: form.mobileNumber,
                password: form.password,
                passwordConfirmation: form.confirmPassword,
            });

            if (result.status === "success") {
                toast.success("Registration successful!");
                handleChange("step", form?.step + 1);
            } else {
                const errorMessage = result?.message || "Registration failed";
                toast.error(errorMessage);
            }
        } catch (error) {
            // Check if error is OTP-related
            const errorMessage = error?.message || "";
            const isOtpError = errorMessage.toLowerCase().includes("otp") ||
                               errorMessage.toLowerCase().includes("invalid") ||
                               errorMessage.toLowerCase().includes("verification") ||
                               errorMessage.toLowerCase().includes("expired");

            if (isOtpError) {
                toast.error("Invalid OTP. Please check and try again.");
            } else {
                toast.error(error?.message || "An error occurred during registration");
            }
        } finally {
            setSubmittingRegistration(false);
        }

    }
    const getLabel = (stp) => {
        if (stp === 3) return "Register"
        return "Save and Continue"
    }
    const isOtpComplete = otp.every((digit) => digit !== "");
    const getDisabledStatus = (stp) => {
        if (stp === 1 && loadingSocietyInfo) return true;
        if (stp === 1 && hasValidationError) return true;
        if (stp === 2 && !form.otpVerificationStatus) return true;
        if (stp === 3 && submittingRegistration) return true;

        return false
    }

    return (
        <>
            <Header onToggle={() => setMenuOpen((v) => !v)} />

            {/* Off-canvas sidebar */}
            <div className={`off-canvas-wrap${menuOpen ? " show-off-canvas" : ""}`}>
                <div
                    className={`overly${menuOpen ? " show-overly" : ""}`}
                    onClick={() => setMenuOpen(false)}
              ></div>
                <div className="off-canvas-widget">
                    <button
                        className="off-canvas-close"
                        onClick={() => setMenuOpen(false)}
                    >
                        <i className="ri-close-line"></i>
                    </button>
                    <div className="off-canvas-menu">
                        <ul className="nav-menu">
                            <li>
                                <a href="/" onClick={(e) => { e.preventDefault(); setMenuOpen(false); navigate("/"); }}>Home</a>
                            </li>
                            <li>
                                <a href="/" onClick={(e) => { e.preventDefault(); setMenuOpen(false); navigate("/", { state: { scrollTo: "rs-about" } }); }}>About</a>
                            </li>
                            <li>
                                <a href="/" onClick={(e) => { e.preventDefault(); setMenuOpen(false); navigate("/", { state: { scrollTo: "rs-scheme" } }); }}>Schemes</a>
                            </li>
                            <li>
                                <a href="/" onClick={(e) => { e.preventDefault(); setMenuOpen(false); navigate("/", { state: { scrollTo: "rs-process" } }); }}>How it Works</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id="scrollUp">
                <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
                    <path
                        d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"
                        fill="#fff"
                    ></path>
                </svg>
                <svg className="scrollprogress" width="40" height="40">
                    <circle
                        className="progress-circle"
                        cx="20"
                        cy="20"
                        r="18"
                        strokeWidth="2"
                        fill="none"
                        stroke="#fff"
                        strokeDasharray="113.1"
                        strokeDashoffset="113.1"
                    ></circle>
                </svg>
            </div>

            <section className="rs-page-banner rs-faq-page-banner pt-50 pb-50 mt-140">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="rs-page-banner__content">
                                <h1 className="title">Society Account Creation</h1>
                                <p>
                                    Complete the RWFMS Society Registration to access the
                                    administrative portal
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rs-faq-page pt-90 pb-120">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="wizard">
                                <div className="progressbar" style={{ display: form?.step === 4 ? 'none' : '' }}>
                                    <div
                                        className="progress-line"
                                        style={{ width: `${progressPercent}%` }}
                                    ></div>

                                    <div
                                        className="d-flex flex-column align-items-center position-relative"
                                        style={{ width: "33.33%" }}
                                    >
                                        <div
                                            className={`progress-step ${form?.step >= 1 ? "active" : ""}`}
                                        >
                                            1
                                        </div>
                                        <div className="step-label">Identification</div>
                                    </div>

                                    <div
                                        className="d-flex flex-column align-items-center position-relative"
                                        style={{ width: "33.33%" }}
                                    >
                                        <div
                                            className={`progress-step ${form?.step >= 2 ? "active" : ""}`}
                                        >
                                            2
                                        </div>
                                        <div className="step-label">Society Details</div>
                                    </div>

                                    <div
                                        className="d-flex flex-column align-items-center position-relative"
                                        style={{ width: "33.33%" }}
                                    >
                                        <div
                                            className={`progress-step ${form?.step >= 3 ? "active" : ""}`}
                                        >
                                            3
                                        </div>
                                        <div className="step-label">Secretary Details</div>
                                    </div>
                                </div>

                                <form id="wizardForm" onSubmit={e => e.preventDefault()} onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}>
                                    <div className={`step ${form?.step === 1 ? "active" : ""}`}>
                                        <div className="checkout-steps-form-style-1">
                                            <ul id="accordionIdenti">
                                                <li>
                                                    <h6 style={{ marginBottom: '20px' }}>
                                                        Society Identification{" "}
                                                    </h6>
                                                    <section
                                                        className="checkout-steps-form-content collapse show"
                                                        id="collapseOne"
                                                        aria-labelledby="headingOne"
                                                        data-bs-parent="#accordionIdenti"
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Society Category</label>
                                                                    <select className="form-control"
                                                                        onChange={(e) => handleChange("societyCategory", e.target.value)}
                                                                        value={form?.societyCategory}
                                                                        disabled={loadingCategories}
                                                                    >
                                                                        <option value=""> {loadingCategories ? "Loading categories..." : "Select Category"}</option>
                                                                        {category.map((categoryItem) => (
                                                                            <option key={categoryItem.id} value={categoryItem.id}>
                                                                                {categoryItem.name}
                                                                            </option>
                                                                        ))}

                                                                    </select>
                                                                    {errors.societyCategory && (
                                                                        <div className="error-text">{errors.societyCategory}</div>
                                                                    )}
                                                                </div>

                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Society District</label>
                                                                    <select
                                                                        className="form-control"
                                                                        onChange={(e) => handleChange("societydistrict", e.target.value)}
                                                                        value={form?.societydistrict}
                                                                        disabled={loadingDistricts}
                                                                    >
                                                                        <option value="">
                                                                            {loadingDistricts ? "Loading districts..." : "Select District"}
                                                                        </option>
                                                                        {districts.map((district) => (
                                                                            <option key={district.id} value={district.id}>
                                                                                {district.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    {errors.societydistrict && (
                                                                        <div className="error-text">{errors.societydistrict}</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Society Taluk</label>
                                                                    <select
                                                                        className="form-control"
                                                                        onChange={(e) => handleChange("societyTaluk", e.target.value)}
                                                                        value={form?.societyTaluk}
                                                                        disabled={!form?.societydistrict || loadingTaluks}
                                                                    >
                                                                        <option value="">
                                                                            {loadingTaluks
                                                                                ? "Loading taluks..."
                                                                                : !form?.societydistrict
                                                                                ? "Select district first"
                                                                                : "Select Taluk"}
                                                                        </option>
                                                                        {taluks.map((taluk) => (
                                                                            <option key={taluk.id} value={taluk.id}>
                                                                                {taluk.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    {errors.societyTaluk && (
                                                                        <div className="error-text">{errors.societyTaluk}</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label>
                                                                    {isKeralaBank() ? "Branch Code" : "Registration Number"}
                                                                </label>

                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={form.registrationNumber}
                                                                    onChange={(e) => handleChange("registrationNumber", e.target.value)}
                                                                    placeholder={isKeralaBank() ? "Enter Branch Code" : "Enter Registration Number"}
                                                                />

                                                                {errors.registrationNumber && (
                                                                    <div className="error-text">{errors.registrationNumber}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className={`step ${form?.step === 2 ? "active" : ""}`}>
                                        <div className="checkout-steps-form-style-1">
                                            <ul id="acoordionPopulated">
                                                <li>
                                                    <h6 style={{ marginBottom: '20px' }}>
                                                        Society Details{" "}
                                                    </h6>
                                                    <section
                                                        className="checkout-steps-form-content collapse show"
                                                        id="collapseOne"
                                                        aria-labelledby="headingOne"
                                                        data-bs-parent="#acoordionPopulated"
                                                    >
                                                        {/* Auto-populated fields in 2-column layout */}
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label style={{ color: '#666', fontSize: '13px', fontWeight: '500' }}>Society Name</label>
                                                                    <p style={{ fontSize: '15px', fontWeight: 'normal', margin: '5px 0', color: '#333' }}>
                                                                        {autoPopDetails.name || "N/A"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label style={{ color: '#666', fontSize: '13px', fontWeight: '500' }}>RCS Unique Code</label>
                                                                    <p style={{ fontSize: '15px', fontWeight: 'normal', margin: '5px 0', color: '#333' }}>
                                                                        {autoPopDetails.rcsUniqueCode || "N/A"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-3">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label style={{ color: '#666', fontSize: '13px', fontWeight: '500' }}>Registered Email Id</label>
                                                                    <p style={{ fontSize: '15px', fontWeight: 'normal', margin: '5px 0', color: '#333' }}>
                                                                        {autoPopDetails.emailId || "N/A"}
                                                                        {form.otpVerificationStatus && (
                                                                            <span style={{ marginLeft: '8px', fontSize: '13px', fontWeight: '700', color: '#1a6b5e', verticalAlign: 'middle' }}>
                                                                                <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle', marginRight: '4px' }}>
                                                                                    <path fill="#1a6b5e" d="M50,5 L56,18 L70,10 L72,24 L86,22 L82,36 L95,40 L87,52 L95,64 L82,68 L86,82 L72,80 L70,94 L56,86 L50,98 L44,86 L30,94 L28,80 L14,82 L18,68 L5,64 L13,52 L5,40 L18,36 L14,22 L28,24 L30,10 L44,18 Z"/>
                                                                                    <polyline points="33,52 44,63 67,38" fill="none" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
                                                                                </svg>
                                                                                Verified
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    {!form?.otpSent && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                handleSendOTP();
                                                                            }}
                                                                            disabled={sendingOTP}
                                                                            style={{ marginTop: '20px' }}
                                                                        >
                                                                            {sendingOTP ? "Sending..." : "Send OTP"}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* OTP Section */}
                                                        {form?.otpSent && !form?.otpVerificationStatus && (
                                                            <div style={{
                                                                backgroundColor: '#e8f5f3',
                                                                border: '1px solid #c4e3de',
                                                                borderRadius: '8px',
                                                                padding: '24px',
                                                                marginTop: '30px'
                                                            }}>
                                                                <h6 style={{ fontWeight: '600', marginBottom: '4px' }}>Email Verification</h6>
                                                                <p style={{ color: '#17a2b8', fontStyle: 'italic', fontSize: '13px', marginBottom: '20px' }}>
                                                                    A new OTP has been sent to your registered email address
                                                                </p>

                                                                {/* OTP inputs + Resend link in one row */}
                                                                <div className="d-flex align-items-center flex-wrap mb-3">
                                                                    <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                                                        {/* OTP Prefix */}
                                                                        {otpPrefix && (
                                                                            <div className="px-3 py-2 border rounded bg-light fw-bold" style={{ minWidth: '60px', textAlign: 'center', fontSize: '14px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                {otpPrefix}
                                                                            </div>
                                                                        )}
                                                                        {otp.map((digit, index) => (
                                                                            <input
                                                                                key={index}
                                                                                id={`otp-${index}`}
                                                                                className="form-control text-center"
                                                                                type="text"
                                                                                maxLength={1}
                                                                                value={digit}
                                                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                                                onChange={(e) => handleOtpChange(e.target.value, index)}
                                                                                disabled={form.otpVerificationStatus}
                                                                                style={{
                                                                                    width: '38px',
                                                                                    height: '38px',
                                                                                    fontSize: '16px',
                                                                                    fontWeight: '600',
                                                                                    textAlign: 'center',
                                                                                    padding: '0',
                                                                                    border: `1px solid ${form.otpVerificationStatus ? '#28a745' : '#aaa'}`,
                                                                                    borderRadius: '4px',
                                                                                    backgroundColor: '#fff'
                                                                                }}
                                                                            />
                                                                        ))}

                                                                        {!verifyingOTP && !showingSuccessToast && !form.otpVerificationStatus && (
                                                                            <span
                                                                                onClick={(!sendingOTP && resendCooldown === 0) ? handleResendOTP : undefined}
                                                                                style={{
                                                                                    color: resendCooldown > 0 ? '#999' : '#17a2b8',
                                                                                    cursor: resendCooldown > 0 ? 'default' : 'pointer',
                                                                                    fontSize: '14px',
                                                                                    textDecoration: 'none',
                                                                                    userSelect: 'none',
                                                                                    marginLeft: '8px'
                                                                                }}
                                                                            >
                                                                                {sendingOTP ? "Sending..." :
                                                                                 resendCooldown > 0 ? `Resend OTP (${resendCooldown}s)` :
                                                                                 "Resend OTP"}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Verify button */}
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <button
                                                                        type="button"
                                                                        className="btn"
                                                                        onClick={handleVerifyOTP}
                                                                        disabled={!isOtpComplete || verifyingOTP || form.otpVerificationStatus}
                                                                        style={{ backgroundColor: '#1a6b5e', color: '#fff', border: 'none' }}
                                                                    >
                                                                        {verifyingOTP ? "Verifying..." : form.otpVerificationStatus ? "Verified" : "Verify"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className={`step ${form?.step === 3 ? "active" : ""}`}>
                                        <div className="checkout-steps-form-style-1">
                                            <ul id="accordionSecretary">
                                                <li>
                                                    <h6 style={{ marginBottom: '20px' }}>
                                                        Secretary Details
                                                    </h6>
                                                    <section
                                                        className="checkout-steps-form-content collapse show"
                                                        id="collapseOne"
                                                        aria-labelledby="headingOne"
                                                        data-bs-parent="#accordionSecretary"
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Secretary Name</label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="Full Legal Name"
                                                                        onChange={(e) => {
                                                                            handleChange("secretaryName", e.target.value);
                                                                            if (e.target.value.length > 25) {
                                                                                setErrors((prev) => ({ ...prev, secretaryName: "Secretary Name must not exceed 25 characters" }));
                                                                            } else {
                                                                                setErrors((prev) => { const { secretaryName, ...rest } = prev; return rest; });
                                                                            }
                                                                        }}
                                                                        onKeyDown={(e) => handleOverviewKeyDown(e)}

                                                                    />

                                                                    {errors.secretaryName && (
                                                                        <div className="error-text">{errors.secretaryName}</div>
                                                                    )}      </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Mobile Number</label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="Please enter mobile number"
                                                                        onChange={(e) => handleChange("mobileNumber", e.target.value)}
                                                                        onKeyDown={(e) => handleNumberKeyDown(e)}
                                                                        maxLength={10}

                                                                    />

                                                                    {errors.mobileNumber && (
                                                                        <div className="error-text">{errors.mobileNumber}</div>
                                                                    )}      </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Enter Password</label>
                                                                    <input
                                                                        className="form-control"
                                                                        type={showPassword ? "text" : "password"}
                                                                        placeholder="*****"
                                                                        onChange={(e) => {
                                                                            handleChange("password", e.target.value);
                                                                            if (e.target.value.length > 12) {
                                                                                setErrors((prev) => ({ ...prev, password: "Password must not exceed 12 characters" }));
                                                                            } else {
                                                                                setErrors((prev) => { const { password, ...rest } = prev; return rest; });
                                                                            }
                                                                        }}

                                                                    />
                                                                    <i
                                                                        className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "15px",
                                                                            top: "50px",
                                                                            cursor: "pointer",
                                                                            color: "#555",
                                                                        }}
                                                                    />

                                                                    {errors.password && (
                                                                        <div className="error-text">{errors.password}</div>
                                                                    )}
                                                                    {!errors.password && (
                                                                        <div style={{ fontSize: '12px', color: '#2e7d32', marginTop: '8px', lineHeight: '1.4' }}>
                                                                            Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character (@$!%*?&) and min 8 characters.
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group input-group">
                                                                    <label htmlFor="">Confirm Password</label>
                                                                    <input
                                                                        className="form-control"
                                                                        type={showcPassword ? "text" : "password"}
                                                                        placeholder="*****"
                                                                        maxLength={12}
                                                                        onChange={(e) => handleChange("confirmPassword", e.target.value)}
                                                                        onPaste={(e) => e.preventDefault()}
                                                                        onCopy={(e) => e.preventDefault()}
                                                                        onCut={(e) => e.preventDefault()}
                                                                    />
                                                                    <i
                                                                        className={`fa ${showcPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                                        onClick={() => setShowxPassword(!showcPassword)}
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "15px",
                                                                            top: "50px",
                                                                            cursor: "pointer",
                                                                            color: "#555",
                                                                        }}
                                                                    />

                                                                    {errors.confirmPassword && (
                                                                        <div className="error-text">{errors.confirmPassword}</div>
                                                                    )}      </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-20">
                                                            <div className="col-md-12">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input width-auto"
                                                                        id="exampleCheck1"
                                                                        onChange={(e) => handleChange("declarationStatus", e.target.checked)}

                                                                    />
                                                                    <label className="form-check-label">
                                                                        I here by declare that the
                                                                        information provided is true to the best of
                                                                        my knowledge and I am authorized to register
                                                                        this society on the administrative portal.
                                                                    </label>

                                                                    {errors.declarationStatus && (
                                                                        <div className="error-text">{errors.declarationStatus}</div>
                                                                    )}      </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className={`step ${form?.step === 4 ? "active" : ""}`}>
                                        <div className="checkout-steps-form-style-1 d-flex justify-content-center align-items-center text-center" style={{ minHeight: "300px" }}>

                                            <div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <svg width="60" height="60" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill="#1a6b5e" d="M50,5 L56,18 L70,10 L72,24 L86,22 L82,36 L95,40 L87,52 L95,64 L82,68 L86,82 L72,80 L70,94 L56,86 L50,98 L44,86 L30,94 L28,80 L14,82 L18,68 L5,64 L13,52 L5,40 L18,36 L14,22 L28,24 L30,10 L44,18 Z"/>
                                                        <polyline points="33,52 44,63 67,38" fill="none" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <h3 className="fw-bold mt-3">Registration Submitted Successfully</h3>
                                                <p className="text-muted mt-2">
                                                    {isBank()
                                                        ? "Your bank registration has been completed successfully."
                                                        : "Your society registration has been completed successfully."
                                                    }
                                                </p>
                                                <p className="text-muted mt-2">Login details have been sent to your registered email address. Please check your email to access your account.</p>

                                                <button
                                                    className="btn btn-primary mt-3"
                                                    onClick={() => {
                                                        clearForm();
                                                        navigate("/")
                                                    }}
                                                >
                                                    Go Home
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    {form.step !== 1 && form.step !== 4 && (
                                        <button
                                            type="button"
                                            className="btn btn-secondary prev-step"
                                            onClick={() => handleChange("step", form?.step - 1)}
                                        >
                                            <i className="ri-arrow-go-back-line ms-2"></i> Back
                                        </button>
                                    )}

                                    {form.step !== 4 && form.step !== 5 && (form.step !== 2 || form.otpVerificationStatus) &&
                                        <button
                                            type="button"
                                            className="btn btn-primary float-end next-step"
                                            onClick={() => handleSubmit()}
                                            disabled={getDisabledStatus(form?.step)}
                                        >
                                            {form.step === 3 && submittingRegistration ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Registering...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="ri-save-line me-2"></i> {getLabel(form?.step)}
                                                </>
                                            )}
                                        </button>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick={false}
                closeButton={true}
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                limit={1}
                style={{ zIndex: 9999 }}
            />
        </>
    );
}

export default Register;
